import React from 'react';
import * as SimilarSeriesSelector from '../../data/SimilarSeriesSelectors';
import CardContainer from './CardContainer';
import SeriesOverviewContainer from 'react/views/series/SeriesOverviewContainer';

const SimilarSeriesContainer = (props) => {
	const seriesModel = SimilarSeriesSelector.getSimilarSeries();
	return (
		<CardContainer
			cardName="Similar Series"
			cardModel={seriesModel}
			component={SeriesOverviewContainer}
			itemsToRender={3}
			onItemClick={props.onItemClick}
			{...props}
		/>
	);
}
export default SimilarSeriesContainer;



// WEBPACK FOOTER //
// ./src/react/containers/SimilarSeriesContainer.jsx